(function () {
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.Theme && window.Theme.moneyFormat) || '${{amount}}';
    var match = formatString.match(placeholderRegex);
    var value;

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getUpsellContainer(el) {
    return el.closest('[data-cart-item-subscription-upsell]');
  }

  function setStep(container, step) {
    if (container) {
      container.setAttribute('data-step', step);
    }
  }

  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('[data-cart-item-subscription-toggle]');
    if (toggleButton) {
      setStep(getUpsellContainer(toggleButton), '2');
      return;
    }

    var backButton = event.target.closest('[data-cart-item-subscription-back]');
    if (backButton) {
      setStep(getUpsellContainer(backButton), '1');
      return;
    }

    var switchButton = event.target.closest('[data-cart-item-switch-to-subscription]');
    if (switchButton) {
      if (switchButton.disabled) {
        return;
      }

      var container = getUpsellContainer(switchButton);
      var selectedPlan = container
        ? container.querySelector('[data-subscription-frequency-radio]:checked')
        : null;

      if (!selectedPlan) {
        return;
      }

      switchButton.disabled = true;

      postJSON('/cart/change.js', {
        id: switchButton.getAttribute('data-cart-key'),
        quantity: parseInt(switchButton.getAttribute('data-quantity'), 10),
        selling_plan: selectedPlan.value
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to switch to Auto Delivery');
          }
          window.location.reload();
        })
        .catch(function () {
          switchButton.disabled = false;
        });

      return;
    }

    var addButton = event.target.closest('[data-free-shipping-upsell-add]');
    if (addButton) {
      if (addButton.disabled) {
        return;
      }
      addButton.disabled = true;

      postJSON('/cart/add.js', {
        id: addButton.getAttribute('data-variant-id'),
        quantity: 1
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to add product');
          }
          window.location.reload();
        })
        .catch(function () {
          addButton.disabled = false;
        });
    }
  });

  // --- "Switch & Save" upsell in the Added-to-cart popup -------------------
  //
  // The cart page/drawer build their subscription upsell server-side (see
  // snippets/cart-item.liquid). The Added-to-cart banner is populated by the
  // vendor theme's own JS after `/cart/add.js` resolves, so this listens for
  // that same jQuery AJAX event (the theme loads jQuery globally) rather than
  // touching the vendor bundle, and injects a widget with the same markup/
  // data-attributes into a slot reserved for it in layout/theme.liquid. That
  // reuses the click handlers above unchanged.

  var atcRequestToken = 0;

  function buildFrequencyOptionHtml(allocation, variantPrice, isFirst, strings, sellingPlansById) {
    var savingsPercent = Math.floor(((variantPrice - allocation.price) * 100) / variantPrice);
    var saveHtml = '';

    if (savingsPercent > 0) {
      saveHtml =
        '<span class="cart-item--subscription-upsell__frequency-save">' +
        strings.savePercentage.replace('__PERCENT__', savingsPercent) +
        '</span>';
    }

    // `/products/{handle}.js` variant allocations only carry a flat
    // `selling_plan_id` — the plan's name lives separately on the product,
    // under `selling_plan_groups[].selling_plans[]`, unlike the cart's own
    // `selling_plan_allocation.selling_plan` object used elsewhere.
    var plan = sellingPlansById[allocation.selling_plan_id];
    var planId = plan ? plan.id : allocation.selling_plan_id;
    var planName = plan && plan.name ? plan.name : '';

    return (
      '<li class="cart-item--subscription-upsell__frequency-item">' +
      '<label class="cart-item--subscription-upsell__frequency-option">' +
      '<input type="radio" class="cart-item--subscription-upsell__frequency-radio" name="atc-subscription-frequency" value="' +
      planId +
      '" data-subscription-frequency-radio' +
      (isFirst ? ' checked' : '') +
      '>' +
      '<span class="cart-item--subscription-upsell__frequency-name">' +
      planName +
      '</span>' +
      '<span class="cart-item--subscription-upsell__frequency-price">' +
      '<span class="money">' +
      formatMoney(allocation.price) +
      '</span>' +
      saveHtml +
      '</span>' +
      '</label>' +
      '</li>'
    );
  }

  function buildSubscriptionUpsellHtml(allocations, variantPrice, cartKey, quantity, strings, sellingPlansById) {
    var headlineSavingsPercent = Math.floor(((variantPrice - allocations[0].price) * 100) / variantPrice);

    var optionsHtml = allocations
      .map(function (allocation, index) {
        return buildFrequencyOptionHtml(allocation, variantPrice, index === 0, strings, sellingPlansById);
      })
      .join('');

    return (
      '<div class="cart-item--subscription-upsell atc-banner--subscription" data-cart-item-subscription-upsell data-step="1">' +
      '<button type="button" class="cart-item--subscription-upsell__step cart-item--subscription-upsell__step--intro" data-subscription-step="1" data-cart-item-subscription-toggle>' +
      '<span class="cart-item--subscription-upsell__text">' +
      strings.switchCta.replace('__PERCENT__', headlineSavingsPercent) +
      '</span>' +
      '<svg class="cart-item--subscription-upsell__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<div class="cart-item--subscription-upsell__step cart-item--subscription-upsell__step--frequency" data-subscription-step="2">' +
      '<p class="cart-item--subscription-upsell__frequency-heading">' +
      strings.chooseFrequency +
      '</p>' +
      '<ul class="cart-item--subscription-upsell__frequency-list">' +
      optionsHtml +
      '</ul>' +
      '<div class="cart-item--subscription-upsell__actions">' +
      '<button type="button" class="cart-item--subscription-upsell__back" data-cart-item-subscription-back>' +
      strings.back +
      '</button>' +
      '<button type="button" class="button-secondary cart-item--subscription-upsell__button" data-cart-item-switch-to-subscription data-cart-key="' +
      cartKey +
      '" data-quantity="' +
      quantity +
      '">' +
      strings.confirmSwitch +
      '</button>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function clearAtcSubscriptionSlot(slot) {
    slot.innerHTML = '';
    slot.hidden = true;
  }

  // The vendor's AddToCartFlyout class clones a hidden `[data-templates]
  // [data-atc-banner]` template into a detached node, fills it in over two
  // chained AJAX calls, and only appends that clone to the header at the very
  // end (`this.header.appendChild(flyOut)`). A plain
  // `document.querySelector('[data-atc-banner-subscription-slot]')` run right
  // after the cart/add response resolves therefore finds the slot inside the
  // still-hidden TEMPLATE, not the clone that is about to become visible — so
  // anything written there never shows up. Instead, this takes the specific
  // banner root element the caller found (the one just inserted into the
  // live DOM) and scopes the slot lookup to it.
  function populateAtcSubscriptionSlot(bannerRoot, addedItem) {
    var slot = bannerRoot.querySelector('[data-atc-banner-subscription-slot]');
    if (!slot) {
      return;
    }

    if (addedItem.selling_plan_allocation) {
      clearAtcSubscriptionSlot(slot);
      return;
    }

    var strings = window.Theme && window.Theme.cartUpsellStrings;
    if (!strings || !addedItem.handle || !addedItem.variant_id) {
      clearAtcSubscriptionSlot(slot);
      return;
    }

    var thisRequest = ++atcRequestToken;

    fetch('/products/' + addedItem.handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load product');
        }
        return response.json();
      })
      .then(function (product) {
        if (thisRequest !== atcRequestToken) {
          return;
        }

        var variant = (product.variants || []).filter(function (v) {
          return v.id === addedItem.variant_id;
        })[0];

        var allocations = (variant && variant.selling_plan_allocations) || [];

        if (allocations.length === 0) {
          clearAtcSubscriptionSlot(slot);
          return;
        }

        var sellingPlansById = {};
        (product.selling_plan_groups || []).forEach(function (group) {
          (group.selling_plans || []).forEach(function (plan) {
            sellingPlansById[plan.id] = plan;
          });
        });

        slot.innerHTML = buildSubscriptionUpsellHtml(
          allocations,
          variant.price,
          addedItem.key,
          addedItem.quantity,
          strings,
          sellingPlansById
        );
        slot.hidden = false;
      })
      .catch(function () {
        if (thisRequest === atcRequestToken) {
          clearAtcSubscriptionSlot(slot);
        }
      });
  }

  // Capture the just-added item's data (variant id, product handle, key —
  // none of which end up in the banner's own DOM) from the same jQuery AJAX
  // call the vendor code itself issues for `/cart/add.js`. empire.js (which
  // defines window.jQuery) loads with the `async` attribute while this file
  // loads with `defer` — defer scripts are not guaranteed to run after async
  // ones finish, so jQuery may not exist yet the first time this file
  // executes. Retry until it shows up instead of checking once.
  var pendingAddedItem = null;
  var atcListenerBound = false;

  function bindAtcAjaxListener() {
    if (atcListenerBound || !window.jQuery) {
      return atcListenerBound;
    }

    window.jQuery(document).ajaxSuccess(function (event, xhr, settings) {
      if (!settings || !settings.url || settings.url.indexOf('cart/add') === -1) {
        return;
      }

      var addedItem;
      try {
        addedItem = JSON.parse(xhr.responseText);
      } catch (error) {
        return;
      }

      if (!addedItem || !addedItem.id) {
        return;
      }

      pendingAddedItem = addedItem;
    });

    atcListenerBound = true;
    return true;
  }

  if (!bindAtcAjaxListener()) {
    window.addEventListener('load', bindAtcAjaxListener);

    var jqueryWaitAttempts = 0;
    var jqueryWaitInterval = setInterval(function () {
      jqueryWaitAttempts += 1;
      if (bindAtcAjaxListener() || jqueryWaitAttempts > 50) {
        clearInterval(jqueryWaitInterval);
      }
    }, 200);
  }

  // Watch for the banner clone actually landing in the DOM
  // (`this.header.appendChild(flyOut)` in empire.js) and populate that
  // specific instance using whichever item's data we most recently captured
  // above — by the time appendChild runs, the cart/add response for that
  // same add has always already resolved.
  var atcHeaderObserver = null;

  function observeAtcBanner() {
    if (atcHeaderObserver) {
      return true;
    }

    var header = document.querySelector('[data-site-header]');
    if (!header) {
      return false;
    }

    atcHeaderObserver = new MutationObserver(function (mutations) {
      if (!pendingAddedItem) {
        return;
      }

      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) {
            continue;
          }
          var banner = node.matches('[data-atc-banner]') ? node : node.querySelector('[data-atc-banner]');
          if (banner) {
            populateAtcSubscriptionSlot(banner, pendingAddedItem);
            pendingAddedItem = null;
            return;
          }
        }
      }
    });

    atcHeaderObserver.observe(header, { childList: true });
    return true;
  }

  if (!observeAtcBanner()) {
    document.addEventListener('DOMContentLoaded', observeAtcBanner);
  }
})();
